import { render, staticRenderFns } from "./FinishedMessage.vue?vue&type=template&id=5a646bf8&scoped=true&"
import script from "./FinishedMessage.vue?vue&type=script&lang=js&"
export * from "./FinishedMessage.vue?vue&type=script&lang=js&"
import style0 from "./FinishedMessage.vue?vue&type=style&index=0&id=5a646bf8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a646bf8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
